export const SERVER_URL = "https://events-app-be.vercel.app"